import {
  Box,
  FormControl,
  FormHelperText,
  InputBase,
  MenuItem,
  Select,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useField, useFormikContext } from "formik";
import { useRef } from "react";
import DownArrow from "../../assets/SVG/downArrow";
import {
  phoneStyleLabel,
  phoneStyleLabelWithError,
  styleLabel,
  styleLabelWithError,
} from "../asarInput/StyleAsaInputCompnent";

export default function AsarFormikSelect({
  name,
  label,
  data,
  placeholder,
  width = undefined,
}) {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const md = useMediaQuery("(max-width:450px)");

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    borderRadius: 8,
    boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
    border: "solid 1px var(--emr-borderInput)",
    padding: "0 4px !important",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    minHeight: 32,
    "&:focus": {
      borderRadius: 8,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
    "&.Mui-error": {
      borderColor: "red",
      boxShadow: "0 0 0 1px var(--emr-red)",
    },
    "& .MuiInputBase-input": {
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      fontSize: md ? 10 : 16,
      paddingRight: "unset !important",
    },
  }));
  const refInput = useRef();

  const handleChange = (event) => {
    setFieldValue(name, event.target.value);
  };

  return (
    <FormControl
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        width: width ?? "100%",
      }}
      variant="standard"
      error={meta.error !== undefined}
    >
      {label && (
        <Typography
          color={"text.primary"}
          sx={
            meta.error
              ? md
                ? phoneStyleLabelWithError
                : styleLabelWithError
              : md
                ? phoneStyleLabel
                : styleLabel
          }
        >
          {label}
        </Typography>
      )}
      <Select
        displayEmpty={true}
        ref={refInput}
        IconComponent={(props) => {
          return (
            <Box
              {...{ className: "", ...props }}
              position="absolute !important"
              top="calc(50% - 0.65em) !important"
              left="0 !important"
              right="auto !important"
              ml="10px !important"
            >
              <DownArrow />
            </Box>
          );
        }}
        value={field.value ?? ""}
        onChange={handleChange}
        placeholder={placeholder}
        input={<BootstrapInput />}
        sx={
          md
            ? {
                ...{ width: "100%" },
                "& .MuiSelect-select": {
                  fontSize: "10px",
                  color: "var(--emr-text-light)",
                },
              }
            : {
                width: "100%",
                "& .MuiSelect-select": {
                  color: "var(--emr-text-light)",
                },
              }
        }
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 40 * 4.5 + 30,
              width: 70,
              backgroundColor: "#F3F3F3",
              borderRadius: "8px",
            },
          },
        }}
        renderValue={(selected) => {
          if (!selected && selected !== 0) {
            return (
              <Typography
                sx={{
                  fontSize: md ? "10px" : "1rem",
                  padding: md ? "4px !important" : "0 4px !important",
                }}
                color={"var(--emr-disable)"}
              >
                {placeholder}
              </Typography>
            );
          }

          return data.find((itr) => itr.id === selected)?.label || selected;
        }}
      >
        {data.map((item) => {
          const key = typeof item === "object" ? item.id : item;
          return (
            <MenuItem key={key} value={key}>
              {item.label ?? item}
            </MenuItem>
          );
        })}
      </Select>
      {meta.error && (
        <FormHelperText sx={{ color: "var(--emr-red)", textAlign: "right" }}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
}
